<template>
  <b-card>
    <!-- filter  -->
    <div
      v-if="loading"
      class="text-center mt-4"
    >
      <b-spinner label="Loading..." />
    </div>
    <div class="col-12 mt-16">
      <div>
        <b-row class="align-items-center">
          <b-col
            lg="4"
            class="my-1"
          >
            <b-form-group
              label=""
              label-for="filter-input"
              label-cols-sm="1"
              label-align-sm="right"
              label-size="sm"
              class="mb-0"
            >
              <b-input-group size="sm">
                <b-form-input
                  id="filter-input"
                  v-model="filter"
                  type="search"
                  placeholder="Type to Search"
                />
                <b-input-group-append>
                  <b-button
                    :disabled="!filter"
                    variant="primary"
                    @click="applyFilter"
                  >Apply</b-button>
                  <b-button
                    :disabled="!filter"
                    @click="clearFilter"
                  >
                    Clear
                  </b-button>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </b-col>
          <!-- .. Filter  for   date-->
          <b-col
            lg="3"
            class="my-1"
          >
            <b-form-input
              id="start-date"
              v-model="startDateFilter"
              type="date"
              placeholder="Select start date"
            />
          </b-col>
          <b-col
            lg="3"
            class="my-1"
          >
            <b-form-input
              id="end-date"
              v-model="endDateFilter"
              type="date"
              placeholder="Select end date"
              @change="changeDate"
            />
          </b-col>
          <!-- Filter  for   date-  -->
          <input
            ref="fileInput"
            type="file"
            accept=".csv"
            style="display: none;"
            @change="handleFileUpload"
          >
          <b-col
            lg="2"
            class="my-1 d-flex justify-content-end"
          >
            <b-button
              variant="primary"
              class="mb-8 mr-8"
              @click="exportAllDataToCSV"
            >
              Export
            </b-button>
          </b-col>
        </b-row>
      </div>
    </div>

    <!-- filter end -->
    <b-row>
      <div class="col-12 mt-16">
        <b-skeleton-table
          v-if="loading"
          :rows="perPage"
          :columns="fields.length"
          animation="wave"
          bordered
          class="mb-3"
        />
        <b-table
          v-else
          id="dataTable"
          :items="users"
          :fields="fields"
          :current-page="currentPage"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          show-empty
          responsive
          striped
          hover
          class="custom-zebra"
        >
          <!-- <b-table id="dataTable" :items="users" :busy.sync="loading" :fields="fields" :current-page="currentPage"
                    :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" show-empty responsive  striped hover  class="custom-zebra"> -->

          <template v-slot:head()="data">
            <span :style="{ color: columnColors[data.field.key] }">{{ data.label }}</span>
          </template>
          <template v-slot:cell()="row">
            <span :style="{ color: columnColors[row.field.key] }">{{ row.value }}</span>
          </template>

          <template #cell(first_name)="row">
            <span :style="{ color: columnColors.first_name }">{{ row.item.first_name }} {{ row.item.last_name }}</span>
          </template>
          <template #cell(city)="row">
            <span :style="{ color: columnColors.city }">{{ row.item.city ||'N/A' }}
            </span>
          </template>
          <template #cell(country)="row">
            <span :style="{ color: columnColors.country }">{{ row.item.country ||'N/A' }}
            </span>
          </template>
          <template #cell(email)="row">
            <span :style="{ color: columnColors.email }">{{ row.item.email ||'N/A' }}</span>
          </template>
          <template #cell(phone_number)="row">
            <span :style="{ color: columnColors.phone_number }"> {{ row.item.phone_number ||'N/A' }}</span>
          </template>
          <template #cell(status)="row">
            <span :style="{color:row.item.status ? 'green':'black'}">
              {{ row.item.status ||'N/A' }}
            </span>
          </template>

          <template #cell(type)="row">
            <span :style="{ color: columnColors.type }">{{ row.item.type ||'N/A' }}</span>
          </template>
          <template #cell(plan_name)="row">
            <span :style="{ color: columnColors.plan_name }">{{ row.item.plan_name ||'N/A' }}</span>
          </template>
          <template #cell(plan_amount)="row">
            <span :style="{ color: columnColors.plan_amount }">{{ row.item.amount }}{{ row.item.currency ? ' ' + row.item.currency : '' ||'N/A' }}</span>
          </template>
          <template #cell(plan_expiry_date)="row">
            <span :style="{ color: columnColors.plan_expiry_date }">
              {{ row.item.plan_expiry_date ? formatDate(row.item.plan_expiry_date) + ' at ' + formatTime(row.item.plan_expiry_date) : 'N/A' }}
            </span>
          </template>
          <template #cell(actions)="row">
            <b-button
              v-b-tooltip.hover
              title="View User"
              variant="link"
              class="p-0"
              @click="showParent(row.item.id)"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="18"
                height="18"
                fill="currentColor"
                style="
                color: rgba(0, 255, 195, 0.87);
                margin-left: 6px;
                margin-bottom: 10px;
              "
                class="bi bi-eye"
                viewBox="0 0 16 16"
              >
                <path
                  d="M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8zM1.173 8a13.133 13.133 0 0 1 1.66-2.043C4.12 4.668 5.88 3.5 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13.133 13.133 0 0 1 14.828 8c-.058.087-.122.183-.195.288-.335.48-.83 1.12-1.465 1.755C11.879 11.332 10.119 12.5 8 12.5c-2.12 0-3.879-1.168-5.168-2.457A13.134 13.134 0 0 1 1.172 8z"
                />
                <path
                  d="M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5zM4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0z"
                />
              </svg>
            </b-button>
            <!-- delete -->
            <b-button
              v-b-tooltip.hover
              title="Delete User"
              variant="link"
              class="p-0 btn-sm mr-2"
              @click="showDeleteConfirmation(row.item.id)"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="18"
                height="18"
                fill="currentColor"
                style="color: red; margin-left: 6px; margin-bottom: 10px"
                class="bi bi-eye"
                viewBox="0 0 16 16"
              >
                <!-- ... your SVG path ... -->
                <path
                  d="M6.5 1h3a.5.5 0 0 1 .5.5v1H6v-1a.5.5 0 0 1 .5-.5ZM11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3A1.5 1.5 0 0 0 5 1.5v1H2.506a.58.58 0 0 0-.01 0H1.5a.5.5 0 0 0 0 1h.538l.853 10.66A2 2 0 0 0 4.885 16h6.23a2 2 0 0 0 1.994-1.84l.853-10.66h.538a.5.5 0 0 0 0-1h-.995a.59.59 0 0 0-.01 0H11Zm1.958 1-.846 10.58a1 1 0 0 1-.997.92h-6.23a1 1 0 0 1-.997-.92L3.042 3.5h9.916Zm-7.487 1a.5.5 0 0 1 .528.47l.5 8.5a.5.5 0 0 1-.998.06L5 5.03a.5.5 0 0 1 .47-.53Zm5.058 0a.5.5 0 0 1 .47.53l-.5 8.5a.5.5 0 1 1-.998-.06l.5-8.5a.5.5 0 0 1 .528-.47ZM8 4.5a.5.5 0 0 1 .5.5v8.5a.5.5 0 0 1-1 0V5a.5.5 0 0 1 .5-.5Z"
                />
              </svg>
            </b-button>
            <b-modal
              v-model="showDeleteConfirmations"
              title="Delete Confirmation"
            >
              <p>Are you sure you want to delete this User?</p>
              <template #modal-footer>
                <b-button
                  variant="primary"
                  @click="deleteItem(itemIdToDelete)"
                >
                  Delete
                </b-button>
                <b-button
                  variant="primary"
                  @click="showDeleteConfirmations = false"
                >
                  Cancel
                </b-button>

              </template>
            </b-modal>
            <!-- end delete -->
            <!-- Edit code here  -->
            <b-button
              v-b-tooltip.hover
              title="Edit User"
              variant="link"
              class="p-0"
              @click="editUser(row.item.id)"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="18"
                height="18"
                fill="currentColor"
                style="color: orange; margin-left: 10px; margin-bottom: 10px"
                class="bi bi-pencil"
                viewBox="0 0 16 16"
              >

                <path
                  d="M12.146.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1 0 .708l-10 10a.5.5 0 0 1-.168.11l-5 2a.5.5 0 0 1-.65-.65l2-5a.5.5 0 0 1 .11-.168l10-10zM11.207 2.5 13.5 4.793 14.793 3.5 12.5 1.207 11.207 2.5zm1.586 3L10.5 3.207 4 9.707V10h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.293l6.5-6.5zm-9.761 5.175-.106.106-1.528 3.821 3.821-1.528.106-.106A.5.5 0 0 1 5 12.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.468-.325z"
                />
              </svg>
            </b-button>

          </template>

          <template v-slot:cell(created_at)="data">
            {{ formatDate(data.item.created_at) }}
          </template>
          <template v-slot:cell(created_at_time)="data">
            {{ formatTime(data.item.created_at) }}
          </template>
          <b-form-group
            label="Filter"
            label-for="filter-input"
            label-cols-sm="3"
            label-align-sm="right"
            label-size="sm"
            class="mb-0"
          >
            <b-input-group size="sm">
              <b-form-input
                id="filter-input"
                v-model="filter"
                type="search"
                placeholder="Type to Search"
              />

              <b-input-group-append>
                <b-button
                  :disabled="!filter"
                  @click="filter = ''"
                >
                  Clear
                </b-button>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
        </b-table>
        <div class="mx-8 d-flex justify-content-end">
          <b-pagination
            v-model="currentPage"
            :total-rows="total"
            :per-page="perPage"
            aria-controls="dataTable"
            @change="pageChanged"
          />
        </div>
        <b-row class="mt-16 align-items-center justify-content-end">
          <b-row />
        </b-row>
      </div>
    </b-row>

    <!-- Soft-deleted users: expand/collapse archive -->
    <div
      v-if="!deletedUsersDismissed"
      class="deleted-archive-panel mt-4"
    >
      <div class="deleted-archive-header d-flex align-items-center justify-content-between px-3 py-2">
        <div class="d-flex align-items-center text-muted small font-weight-bold text-uppercase letter-spacing">
          <b-icon
            icon="trash"
            class="mr-2"
            font-scale="0.95"
          />
          Deleted users
        </div>
        <div class="d-flex align-items-center">
          <b-button
            variant="light"
            size="sm"
            class="py-0 px-2 archive-toggle-btn"
            :aria-expanded="deletedUsersExpanded ? 'true' : 'false'"
            @click="toggleDeletedUsersExpand"
          >
            {{ deletedUsersExpanded ? '−' : '+' }}
          </b-button>
          <b-button
            v-b-tooltip.hover
            variant="light"
            size="sm"
            class="py-0 px-2 ml-1 archive-toggle-btn"
            title="Hide section"
            @click="deletedUsersDismissed = true"
          >
            ×
          </b-button>
        </div>
      </div>
      <div
        v-show="deletedUsersExpanded"
        class="deleted-archive-body border-top px-3 pb-3 pt-3"
      >
        <b-row
          class="align-items-center mb-3"
          no-gutters
        >
          <b-col
            cols="12"
            md="7"
            class="mb-2 mb-md-0"
          >
            <b-button-toolbar aria-label="Export deleted users">
              <b-button-group
                size="sm"
                class="flex-wrap"
              >
                <b-button
                  variant="outline-secondary"
                  @click="copyDeletedUsersTable"
                >
                  COPY
                </b-button>
                <b-button
                  variant="outline-secondary"
                  @click="exportDeletedUsersCsv"
                >
                  CSV
                </b-button>
                <b-button
                  variant="outline-secondary"
                  @click="exportDeletedUsersExcel"
                >
                  EXCEL
                </b-button>
                <b-button
                  variant="outline-secondary"
                  @click="exportDeletedUsersPdf"
                >
                  PDF
                </b-button>
                <b-button
                  variant="outline-secondary"
                  @click="printDeletedUsersTable"
                >
                  PRINT
                </b-button>
              </b-button-group>
            </b-button-toolbar>
          </b-col>
          <b-col
            cols="12"
            md="5"
          >
            <b-input-group size="sm">
              <b-form-input
                v-model="deletedUsersFilter"
                type="search"
                placeholder="Search deleted users"
                @keyup.enter="applyDeletedUsersSearch"
              />
              <b-input-group-append>
                <b-button
                  variant="primary"
                  :disabled="!deletedUsersFilter"
                  @click="applyDeletedUsersSearch"
                >
                  Apply
                </b-button>
                <b-button
                  :disabled="!deletedUsersFilter"
                  @click="clearDeletedUsersSearch"
                >
                  Clear
                </b-button>
              </b-input-group-append>
            </b-input-group>
          </b-col>
        </b-row>
        <div
          v-show="deletedUsersLoading"
          class="text-center py-3"
        >
          <b-spinner small />
        </div>
        <div
          v-show="!deletedUsersLoading"
          ref="deletedUsersPdf"
          class="deleted-users-print-area"
        >
          <b-table
            :items="deletedUsersList"
            :fields="deletedUsersFields"
            show-empty
            responsive
            striped
            hover
            small
            empty-text="No deleted users found."
            class="custom-zebra mb-0"
          >
            <template #cell(display_name)="row">
              {{ row.item.display_name }}
            </template>
            <template #cell(type)="row">
              <b-badge
                variant="light"
                class="text-dark border"
              >
                {{ row.item.type || '—' }}
              </b-badge>
            </template>
            <template #cell(deleted_at_display)="row">
              {{ row.item.deleted_at_display }}
            </template>
            <template #cell(actions)="row">
              <b-button
                v-b-tooltip.hover
                title="Restore user"
                variant="link"
                class="p-0 restore-action-btn"
                @click="openRestoreUserModal(row.item)"
              >
                <i
                  class="fas fa-undo-alt"
                  aria-hidden="true"
                />
              </b-button>
            </template>
          </b-table>
        </div>
        <div class="d-flex justify-content-end mt-2">
          <b-pagination
            v-if="deletedUsersTotal > 0"
            v-model="deletedUsersCurrentPage"
            :total-rows="deletedUsersTotal"
            :per-page="deletedUsersPerPage"
            size="sm"
            class="mb-0"
            @change="deletedUsersPageChanged"
          />
        </div>
      </div>
    </div>
    <div
      v-else
      class="mt-3"
    >
      <b-button
        variant="link"
        size="sm"
        class="p-0"
        @click="deletedUsersDismissed = false"
      >
        Show deleted users
      </b-button>
    </div>

    <b-modal
      v-model="showRestoreUserModal"
      title="Restore user"
      hide-footer
      centered
    >
      <p class="mb-0">
        Restore <strong>{{ restoreUserName }}</strong> to the active user list?
      </p>
      <div class="d-flex justify-content-end mt-3">
        <b-button
          variant="secondary"
          class="mr-2"
          @click="showRestoreUserModal = false"
        >
          Cancel
        </b-button>
        <b-button
          variant="primary"
          :disabled="restoreUserSubmitting"
          @click="confirmRestoreUser"
        >
          <b-spinner
            v-if="restoreUserSubmitting"
            small
            class="mr-1"
          />
          Restore
        </b-button>
      </div>
    </b-modal>
  </b-card>
</template>

<script>
import {
  BRow,
  BCol,
  BCard,
  BButton,
  BTable,
  BFormGroup,
  BInputGroup,
  BFormInput,
  BPagination,
  BInputGroupAppend,
  BSpinner,
  BSkeletonTable,
  BBadge,
  BButtonToolbar,
  BButtonGroup,
} from 'bootstrap-vue'
import Papa from 'papaparse'
import axios from '../../../axios'

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BButton,
    BTable,
    BFormGroup,
    BInputGroup,
    BFormInput,
    BPagination,
    BInputGroupAppend,
    BSpinner,
    BSkeletonTable,
    BBadge,
    BButtonToolbar,
    BButtonGroup,
  },
  data() {
    return {
      filter: '',
      total: 0,
      perPage: 10,
      currentPage: 1,
      lastPage: 0,
      firstPageUrl: null,
      lastPageUrl: null,
      nextPageUrl: null,
      prevPageUrl: null,
      isLoading: false,
      sortBy: '',
      sortDesc: false,
      selectedCardOption: '',
      rowToUpdate: null,
      modalVisible: false,
      modalVisibleDoument: false,
      editMode: false,
      users: [],
      fields: [
        { key: 'id', sortable: true },
        { key: 'first_name', label: 'Name', sortable: true },
        { key: 'email', sortable: true },
        { key: 'phone_number', sortable: true },
        { key: 'city', sortable: true },
        { key: 'country', sortable: true },
        { key: 'vehicle_pending_count', label: 'Pending Vehicle', sortable: true },
        { key: 'created_at', label: 'Date', formatter: this.formatDate },
        { key: 'created_at_time', label: 'Time' },
        { key: 'type', label: 'User Type' },
        { key: 'status', sortable: true },
        { key: 'plan_name', label: 'Plan Subscribed' },
        { key: 'plan_amount', label: 'Plan Amount' },
        { key: 'plan_expiry_date', label: 'Plan Expiry Date' },
        { key: 'actions', label: 'Actions' },
      ],
      columnColors: {
        first_name: 'blue',
        email: 'green',
        phone_number: 'red',
        city: 'purple',
        country: 'orange',
        vehicle_pending_count: 'brown',
        created_at: 'maroon',
        created_at_time: 'navy',
        type: 'olive',
        status: 'indigo',
        plan_name: 'teal',
        plan_amount: 'gray',
        plan_expiry_date: 'palevioletred',
        actions: 'gold',
      },

      showDeleteConfirmations: false,
      itemIdToDelete: null,
      loading: false,
      // startDateFilter: "",
      // endDateFilter: "",
      startDateFilter: null,
      endDateFilter: null,
      ended_date: '',
      selected_date: '',

      your_vehicle_id: null,
      name: '',
      email: '',
      phone_number: '',
      city: '',
      country: '',
      type: '',
      status: '',
      plan_name: '',
      plan_amount: '',
      plan_expiry_date: '',

      deletedUsersDismissed: false,
      deletedUsersExpanded: false,
      deletedUsersLoading: false,
      deletedUsersList: [],
      deletedUsersFilter: '',
      deletedUsersActiveSearch: '',
      deletedUsersCurrentPage: 1,
      deletedUsersTotal: 0,
      deletedUsersPerPage: 10,
      deletedUsersFields: [
        { key: 'id', label: 'ID', sortable: true },
        { key: 'display_name', label: 'Name', sortable: true },
        { key: 'email', sortable: true },
        { key: 'phone_number', label: 'Phone', sortable: true },
        { key: 'type', label: 'Type', sortable: true },
        { key: 'city', sortable: true },
        { key: 'deleted_at_display', label: 'Archived at', sortable: true },
        { key: 'actions', label: 'Option' },
      ],
      showRestoreUserModal: false,
      restoreUserId: null,
      restoreUserName: '',
      restoreUserSubmitting: false,
    }
  },
  computed: {
    sortOptions() {
      return this.fields
        .filter(f => f.sortable)
        .map(f => ({ text: f.label, value: f.key }))
    },
    rows() {
      return this.users.length
    },
  },
  mounted() {
    this.fetchData()
  },
  methods: {
    clearFilter() {
      this.filter = ''
      this.currentPage = 1
      this.fetchData()
    },
    async fetchData() {
      this.loading = true
      const apiUrl = 'ReguestGetApproved'
      try {
        const response = await axios.get(apiUrl, {
          params: {
            page: this.currentPage,
            per_page: this.perPage,
            ended_date: this.endDateFilter,
            selected_date: this.startDateFilter,
          },
        })

        this.users = response.data.data
        this.total = response.data.total
        this.currentPage = response.data.current_page
        this.perPage = response.data.per_page
        this.lastPage = response.data.last_page
      } catch (error) {

      } finally {
        this.loading = false
      }
    },

    pageChanged(newPage) {
      this.currentPage = newPage
      this.fetchData()
    },
    // import  code
    triggerFileInput() {
      this.$refs.fileInput.click()
    },
    handleFileUpload(event) {
      const file = event.target.files[0]
      if (file && file.type === 'text/csv') {
        this.fileToUpload = file
        this.importStudents()
      } else {
        alert('Please select a valid CSV file.')
      }
    },
    async importStudents() {
      const formData = new FormData()
      formData.append('file', this.fileToUpload)

      this.loading = true

      try {
        const response = await axios.post('importParents', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        })
        // Display success toast message
        this.$bvToast.toast('File uploaded successfully.', {
          title: 'Success',
          variant: 'primary',
          solid: true,
          appendToast: true,
          toaster: 'b-toaster-top-right',
          autoHideDelay: 5000,
        })
      } catch (error) {
        console.error('Error uploading CSV file:', error)
        this.$bvToast.toast('Failed to upload CSV file.', {
          title: 'Error',
          variant: 'danger',
          solid: true,
          appendToast: true,
          toaster: 'b-toaster-top-right',
          autoHideDelay: 5000,
        })
      } finally {
        this.loading = false
      }
    },
    applyFilter() {
      this.loading = true
      const apiUrl = 'ReguestGetApproved'
      axios
        .get(apiUrl, {
          params: {
            search: this.filter,
          },
        })
        .then(response => {
          this.users = response.data.data
          this.total = response.data.total
          this.currentPage = response.data.current_page
        })
        .catch(error => {

        })
        .finally(() => {
          this.loading = false
        })
    },
    openModal() {
      this.resetFormFields()

      this.modalVisible = true
    },
    uploadDocuments() {
      this.resetUploadDocument()

      this.modalVisibleDoument = true
    },

    onFiltered(filteredItems) {
      this.total = filteredItems.length
      this.currentPage = 1
    },
    uploadDocuments(studentId) {
      this.resetUploadDocument()
      this.studentId = studentId
      this.modalVisibleDoument = true
    },
    resetUploadDocument() {
      this.documents = ''
      this.studentId = null
    },

    codeClick() {
      this.codeActive = !this.codeActive
    },
    exportAllDataToCSV() {
      this.fetchAllParents(allParents => {
        const csv = Papa.unparse(allParents)
        const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' })
        const link = document.createElement('a')
        link.href = URL.createObjectURL(blob)
        link.setAttribute('download', 'exported_data.csv')
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
      })
    },
    fetchAllParents(callback) {
      axios
        .get('approvedAllUsersForExport', { params: { per_page: this.totalRows } })
        .then(response => {
          callback(response.data.data)
        })
        .catch(error => {

        })
    },
    // View  and  Edit  code  here
    editUser(userId) {
      this.$router.push({ name: 'EditUser', params: { id: userId } })
    },

    showParent(userId) {
      this.$router.push({ name: 'ViewUser', params: { id: userId } })
    },
    // delete  code here
    showDeleteConfirmation(itemId) {
      this.itemIdToDelete = itemId
      this.showDeleteConfirmations = true
    },

    deleteItem(itemId) {
      this.itemIdToDelete = itemId // Set the item ID to be deleted
      axios
        .delete(`registration/${itemId}`)
        .then(response => {
          this.showDeleteConfirmations = false
          this.fetchData() // Refresh the data after deletion
        })
        .catch(error => {

        })
    },

    downloadFile(fileUrl) {
      const link = document.createElement('a')
      link.href = `https://boltapi.fastnetstaffing.in/${fileUrl}`
      link.download = 'downloaded_file'
      link.target = '_blank'
      link.click()
    },

    handleButtonClick(item) {
      this.updateStatus(item)
      this.toggleCardModal(item)
    },
    updateStatus(user) {
      user.status = user.status === 'Approved' ? 'Pending' : 'Approved'
      axios
        .post(`registrationUpdate/${user.id}`, user)
        .then(response => {

        })
        .catch(error => {

        })
    },
    toggleCardModal(item) {
      this.selectedCardOption = ''
      this.rowToUpdate = item
      this.isCardModalVisible = true
    },
    // Display  date  code  here
    formatDate(dateString) {
      if (!dateString) return ''
      const date = new Date(dateString)
      return date.toISOString().split('T')[0]
    },
    // Display  time  code  here
    formatTime(dateString) {
      if (!dateString) return ''
      const date = new Date(dateString)
      return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })
    },
    // For  date  vise  fetch  data
    changeDate() {
      const userId = this.$route.params.id
      this.fetchData(userId)
    },

    toggleDeletedUsersExpand() {
      this.deletedUsersExpanded = !this.deletedUsersExpanded
      if (this.deletedUsersExpanded) {
        this.fetchDeletedUsers()
      }
    },
    deletedUsersPageChanged(page) {
      this.deletedUsersCurrentPage = page
      this.fetchDeletedUsers()
    },
    applyDeletedUsersSearch() {
      this.deletedUsersActiveSearch = this.deletedUsersFilter
      this.deletedUsersCurrentPage = 1
      this.fetchDeletedUsers()
    },
    clearDeletedUsersSearch() {
      this.deletedUsersFilter = ''
      this.deletedUsersActiveSearch = ''
      this.deletedUsersCurrentPage = 1
      this.fetchDeletedUsers()
    },
    formatDeletedUserDisplayName(u) {
      const nameParts = [u.first_name, u.second_name, u.last_name, u.second_last_name].filter(Boolean)
      if (nameParts.length) return nameParts.join(' ')
      return u.company_name || '—'
    },
    relativeDeletedAt(iso) {
      if (!iso) return '—'
      const t = new Date(iso).getTime()
      if (Number.isNaN(t)) return '—'
      const sec = Math.floor((Date.now() - t) / 1000)
      if (sec < 45) return 'just now'
      if (sec < 3600) {
        const m = Math.floor(sec / 60)
        return `${m} min ago`
      }
      if (sec < 86400) {
        const h = Math.floor(sec / 3600)
        return `${h} hour${h === 1 ? '' : 's'} ago`
      }
      const d = Math.floor(sec / 86400)
      if (d < 30) return `${d} day${d === 1 ? '' : 's'} ago`
      const mo = Math.floor(d / 30)
      if (mo < 12) return `${mo} mo ago`
      const y = Math.floor(mo / 12)
      return `${y} yr ago`
    },
    mapDeletedUserRows(items) {
      return (items || []).map(u => ({
        ...u,
        display_name: this.formatDeletedUserDisplayName(u),
        deleted_at_display: this.relativeDeletedAt(u.deleted_at),
      }))
    },
    async fetchDeletedUsers() {
      if (!this.deletedUsersExpanded) return
      this.deletedUsersLoading = true
      try {
        const response = await axios.get('deletedUsers', {
          params: {
            page: this.deletedUsersCurrentPage,
            search: this.deletedUsersActiveSearch || undefined,
          },
        })
        const body = response.data
        if (!body.data || !Array.isArray(body.data)) {
          this.deletedUsersList = []
          this.deletedUsersTotal = 0
          return
        }
        this.deletedUsersList = this.mapDeletedUserRows(body.data)
        this.deletedUsersTotal = body.total || 0
        this.deletedUsersPerPage = body.per_page || 10
        this.deletedUsersCurrentPage = body.current_page || 1
      } catch (e) {
        this.deletedUsersList = []
        this.deletedUsersTotal = 0
        this.$bvToast.toast('Could not load deleted users.', {
          variant: 'danger',
          solid: true,
          toaster: 'b-toaster-top-right',
        })
      } finally {
        this.deletedUsersLoading = false
      }
    },
    deletedUsersExportRows() {
      return this.deletedUsersList.map(u => ({
        id: u.id,
        name: u.display_name,
        email: u.email || '',
        phone: u.phone_number || '',
        type: u.type || '',
        city: u.city || '',
        archived_at: u.deleted_at || '',
      }))
    },
    async copyDeletedUsersTable() {
      const rows = this.deletedUsersExportRows()
      if (!rows.length) {
        this.$bvToast.toast('Nothing to copy.', { variant: 'warning', solid: true, toaster: 'b-toaster-top-right' })
        return
      }
      const header = Object.keys(rows[0]).join('\t')
      const lines = rows.map(r => Object.values(r).join('\t'))
      try {
        await navigator.clipboard.writeText([header, ...lines].join('\n'))
        this.$bvToast.toast('Copied to clipboard.', { variant: 'primary', solid: true, toaster: 'b-toaster-top-right' })
      } catch (err) {
        this.$bvToast.toast('Copy failed.', { variant: 'danger', solid: true, toaster: 'b-toaster-top-right' })
      }
    },
    exportDeletedUsersCsv() {
      const rows = this.deletedUsersExportRows()
      if (!rows.length) {
        this.$bvToast.toast('No data to export.', { variant: 'warning', solid: true, toaster: 'b-toaster-top-right' })
        return
      }
      const csv = Papa.unparse(rows)
      const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' })
      const link = document.createElement('a')
      link.href = URL.createObjectURL(blob)
      link.download = 'deleted-users.csv'
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    },
    exportDeletedUsersExcel() {
      const rows = this.deletedUsersExportRows()
      if (!rows.length) {
        this.$bvToast.toast('No data to export.', { variant: 'warning', solid: true, toaster: 'b-toaster-top-right' })
        return
      }
      const csv = `\ufeff${Papa.unparse(rows)}`
      const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' })
      const link = document.createElement('a')
      link.href = URL.createObjectURL(blob)
      link.download = 'deleted-users-excel.csv'
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    },
    async exportDeletedUsersPdf() {
      const el = this.$refs.deletedUsersPdf
      if (!el || !this.deletedUsersList.length) {
        this.$bvToast.toast('No data for PDF.', { variant: 'warning', solid: true, toaster: 'b-toaster-top-right' })
        return
      }
      const html2pdf = (await import('html2pdf.js')).default
      await html2pdf()
        .from(el)
        .set({
          margin: 8,
          filename: 'deleted-users.pdf',
          html2canvas: { scale: 2 },
          jsPDF: { unit: 'mm', format: 'a4', orientation: 'landscape' },
        })
        .save()
    },
    printDeletedUsersTable() {
      const el = this.$refs.deletedUsersPdf
      if (!el || !this.deletedUsersList.length) {
        this.$bvToast.toast('Nothing to print.', { variant: 'warning', solid: true, toaster: 'b-toaster-top-right' })
        return
      }
      const w = window.open('', '_blank')
      if (!w) return
      w.document.write(`<!DOCTYPE html><html><head><title>Deleted users</title></head><body>${el.innerHTML}</body></html>`)
      w.document.close()
      w.focus()
      w.print()
      w.close()
    },
    openRestoreUserModal(item) {
      this.restoreUserId = item.id
      this.restoreUserName = item.display_name || String(item.id)
      this.showRestoreUserModal = true
    },
    async confirmRestoreUser() {
      if (!this.restoreUserId) return
      this.restoreUserSubmitting = true
      try {
        await axios.post(`restoreUser/${this.restoreUserId}`)
        this.$bvToast.toast('User restored successfully.', {
          variant: 'success',
          solid: true,
          toaster: 'b-toaster-top-right',
        })
        this.showRestoreUserModal = false
        this.restoreUserId = null
        this.fetchDeletedUsers()
        this.fetchData()
      } catch (error) {
        const msg = error.response && error.response.data && error.response.data.message
          ? error.response.data.message
          : 'Restore failed.'
        this.$bvToast.toast(msg, { variant: 'danger', solid: true, toaster: 'b-toaster-top-right' })
      } finally {
        this.restoreUserSubmitting = false
      }
    },
  },

}
</script>
<style>
/* Zebra striping */
.custom-zebra tbody tr:nth-of-type(odd) {
  background-color: #f0f2f5; /* darker than default */
}

/* Hover effect */
.custom-zebra tbody tr:hover {
  background-color: #e0e4ea !important; /* slightly darker hover */
}

.deleted-archive-panel {
  border: 1px solid #e2e5ea;
  border-radius: 6px;
  background: #fafbfc;
}
.deleted-archive-header {
  background: #f4f5f7;
  border-radius: 6px 6px 0 0;
  border-bottom: 1px solid #e2e5ea;
}
.deleted-archive-body {
  background: #fff;
  border-radius: 0 0 6px 6px;
}
.archive-toggle-btn {
  min-width: 2rem;
  font-weight: 600;
  line-height: 1.2;
}
.letter-spacing {
  letter-spacing: 0.04em;
}
.restore-action-btn {
  color: #2c7be5;
}
.restore-action-btn:hover {
  color: #1a68d1;
}
</style>
